import { createColumnHelper } from "@tanstack/react-table";
import { ILocation } from "./utils/Location-utils";
import LocationActionButton from "./utils/LocationActionsButtons";
import Chip from "@mui/material/Chip";
import { usePermission } from "../../../../hooks/usePermissions";
import { Modules, Permissions } from "../../../Users/Roles/roles-utils";

const columnHelper = createColumnHelper<ILocation>();

const LocationColumns = (onOpenMembers?: (location: ILocation, position: { top: number; left: number }) => void) => {
  const hasEditPermission = usePermission(
    Modules.mmdLoc.accessKey,
    Permissions.edit
  );
  const hasDeletePermission = usePermission(
    Modules.mmdLoc.accessKey,
    Permissions.delete
  );

  return [
    columnHelper.accessor("id", {
      id: "id",
      header: "Item No",
      cell: ({ row }) => row.index + 1,
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("name", {
      id: "name",
      header: "Name",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("streetLocation", {
      id: "streetLocation",
      header: "Street Location",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("type", {
      id: "type",
      header: "Type",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("userIds", {
      id: "members",
      header: "Members",
      cell: ({ row }) => {
        const count = row.original.userIds?.length || 0;
        return (
          <Chip
            label={count > 0 ? `${count} ${count === 1 ? "Member" : "Members"}` : "No Members"}
            color="primary"
            variant="outlined"
            onClick={(e) => {
              e.stopPropagation();
              const rect = e.currentTarget.getBoundingClientRect();
              onOpenMembers?.(row.original, {
                top: rect.bottom + 6,
                left: rect.left + rect.width / 2,
              });
            }}
            sx={{ cursor: "pointer", height: "25px", fontWeight: 500 }}
          />
        );
      },
      enableGlobalFilter: false,
      enableColumnFilter: false,
    }),
    columnHelper.accessor("isActive", {
      id: "isActive",
      header: "Status",
      cell: (row) => (
        <Chip
          label={row.getValue() ? "Active" : "Inactive"}
          color={row.getValue() ? "primary" : "warning"}
          style={{ color: row.getValue() ? "white" : "white", height: "25px" }}
        />
      ),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    ...(hasEditPermission || hasDeletePermission
      ? [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => <LocationActionButton location={row.original} hasEditPermission={hasEditPermission} hasDeletePermission={hasDeletePermission} />,
            enableHiding: false,
          }),
        ]
      : []),
  ];
};

export default LocationColumns;
